<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
    <path
      d="M14.7 12.3V.5c0-.2-.2-.3-.4-.3l-4.2 2.1-4.6-2h-.2L.4 2.4c-.1 0-.2.1-.2.3v11.8c0 .1 0 .2.1.2.1.1.2.1.3 0l4.7-2.1 4.7 2.1h.4l4.2-2.1c.1-.1.1-.2.1-.3zm-9.6-.2L.8 14V2.9L5.1 1v11.1zM9.9 14l-4.2-1.9V1l4.2 1.9V14zm4.3-1.9L10.5 14V2.9L14.2 1v11.1z"
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconMap',
};
</script>

<style></style>
